<template>
  <div class="schedule-card">
    <div class="module-title">灌溉计划日历</div>
    <div class="schedule-table">
      <div class="table-head">
        <span>日期</span>
        <span>计划面积</span>
        <span>预计用水量</span>
        <span>执行状态</span>
      </div>
      <div v-for="item in scheduleRows" :key="item.date + item.status" class="table-row">
        <span>{{ item.date }}</span>
        <span>{{ item.area }}</span>
        <span>{{ item.water }}</span>
        <span :class="['status', item.type]">{{ item.status }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
const scheduleRows = [
  { date: "07-09", area: "320亩", water: "520吨", status: "已完成", type: "done" },
  { date: "07-09", area: "410亩", water: "680吨", status: "执行中", type: "doing" },
  { date: "07-10", area: "380亩", water: "610吨", status: "待执行", type: "todo" },
  { date: "07-10", area: "290亩", water: "470吨", status: "待执行", type: "todo" },
  { date: "07-11", area: "360亩", water: "590吨", status: "待执行", type: "todo" },
  { date: "07-11", area: "260亩", water: "420吨", status: "待执行", type: "todo" },
  { date: "07-12", area: "340亩", water: "560吨", status: "待执行", type: "todo" },
  { date: "07-12", area: "300亩", water: "500吨", status: "待执行", type: "todo" },
];
</script>

<style lang="less" scoped>
.schedule-card {
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: 0 0 24px;
  box-sizing: border-box;
}

.module-title {
  position: relative;
  height: 68px;
  line-height: 68px;
  padding-left: 18px;
  color: #ffffff;
  font-size: 26px;
  font-weight: bold;
  text-align: left;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 20px;
    width: 5px;
    height: 28px;
    background: #39fff0;
    box-shadow: 0 0 12px rgba(57, 255, 240, 0.8);
  }
}

.schedule-table {
  width: 100%;
  height: calc(100% - 78px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.table-head,
.table-row {
  flex: 1;
  display: grid;
  grid-template-columns: 1.05fr 1.2fr 1.25fr 1.1fr;
  align-items: center;
  text-align: center;
  color: #fff;
}

.table-head {
  height: 60px;
  background: rgba(16, 142, 130, 0.8);
  color: #d9fffb;
  font-size: 22px;
  font-weight: bold;
}

.table-row {
  height: 60px;
  background: rgba(6, 122, 111, 0.1);
  color: #f4fffb;
  font-size: 24px;
  font-weight: bold;

  &:nth-child(odd) {
    background: rgba(0, 95, 86, 0.4);
  }
}

.status {
  color: #fff;
}

.status.done {
  color: #f8fffd;
}

.status.doing {
  color: #fff7cc;
}

.status.todo {
  color: #dffcf8;
}
</style>
